export default __webpack_public_path__ + "static/media/profile_new.2bc70212.JPG";